/* eslint-disable no-param-reassign */
import { isObject } from 'lodash';
import { StateCreator } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { devToolOptions } from './devToolOptions';
import { getDevtoolsName } from './getDevtoolsName';
import { getPersistName } from './getPersistName';
import { MiddlewareOptions } from './types/MiddlewareOptions';

/**
 * Applies Zustand middleware (`devtools`, `persist`) to the given store creator.
 */
export const withMiddleware = <T>(
  creator: StateCreator<T, [], any>,
  id: string,
  middlewares: MiddlewareOptions<T> = {},
): StateCreator<T, [], any> => {
  const { devtools: devtoolsOption, persist: persistOption } = middlewares;

  if (devtoolsOption) {
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
      (window as any).__REDUX_DEVTOOLS_EXTENSION__();

    creator = devtools(creator, devToolOptions(getDevtoolsName(id)));
  }

  if (persistOption) {
    const options = isObject(persistOption) ? persistOption : {};

    creator = persist(creator, {
      name: getPersistName(id),
      ...options,
    });
  }

  return creator;
};
